import React, { Component } from 'react';
// utils
import classnames from 'classnames';
import { Translations, convertStringToArray, getArrayToString, getStringToArray } from '../../../utils';
// constant
import {
  CASE_CANCELLED,
  CASE_COMPLETED,
  DOCUMENTATION_DRAFT,
  INITAL_REQUEST_DATA_READY,
  INITIAL_REQUEST_INCOMPLETE,
  ECHANNEL_HSBCAPI
} from '../../../constants';
// children
import AddUserSearchBox from '../../Admin/AdminPanel/AddUserSearchBox/';
import Checkbox from '../../common/Checkbox/Checkbox';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../common/Modal';
import Radio from '../../common/Radio/radioButton';
import SimpleDropdown from '../../common/SimpleDropdown';
import OtherProductsList from './OtherProductsListModal/otherProductsList';

export const SubmitRequestModal = (props) => {
  const caseIds = props.sow ? '' : Object.keys(props.cases);

  let disabledBtn = props.sow ? false : (props._enableGenerateDraftBtn.length > 0 ? false : true)
  let entitiesListJsx = "";
  let sowListJsx = "";
  let pathSelectionRadioGroupJsx = null;
  if (props.sow) {
    sowListJsx = (<label>{`${props.sowDetail.registeredName} (${props.sowDetail.entityId})`}</label>)
  }
  if (caseIds.length === 1) {
    props._caseSelectedSingleEntity(caseIds[0]);
    entitiesListJsx = (<label>{`${props.cases[caseIds[0]].entityName} (${props.cases[caseIds[0]]._caseId})`}</label>)
  } else if (!props.sow) {
    entitiesListJsx = caseIds.map((caseId) => (
      <div key={caseId}
        className={`checkbox-container ${(((props.generateDoc[caseId] !== undefined && Object.keys(props.generateDoc).length > 0 ? props.generateDoc[caseId].generateDoc : '') && props.cases[caseId].status === INITIAL_REQUEST_INCOMPLETE) || props.cases[caseId].status === INITAL_REQUEST_DATA_READY || props.cases[caseId].status === DOCUMENTATION_DRAFT) ? '' : 'disabled'}`}
      >
        <Checkbox
          onChange={props._caseSelectedMultiEntity}
          name={caseId}
          id={caseId}
          disabled={!(props.cases[caseId].status === INITAL_REQUEST_DATA_READY || props.cases[caseId].status === DOCUMENTATION_DRAFT || ((props.generateDoc[caseId] !== undefined && Object.keys(props.generateDoc).length > 0 ? props.generateDoc[caseId].generateDoc : '') && props.cases[caseId].status === INITIAL_REQUEST_INCOMPLETE))}
          checked={props._enableGenerateDraftBtn.includes(caseId) && ((props.cases[caseId].status === INITAL_REQUEST_DATA_READY || props.cases[caseId].status === DOCUMENTATION_DRAFT || ((props.generateDoc[caseId] !== undefined && Object.keys(props.generateDoc).length > 0 ? props.generateDoc[caseId].generateDoc : '') && props.cases[caseId].status === INITIAL_REQUEST_INCOMPLETE)))}
          controlled={props._enableGenerateDraftBtn.includes(caseId)}
        />
        <label htmlFor={caseId}>
          <span className="product-enablement-text">
            {`${props.cases[caseId].entityName}_${props.cases[caseId]._caseId}`}
          </span>
          <span><b>{` (${props.cases[caseId].statusValue})`}</b></span>
        </label>
      </div>
    ));
  }

  pathSelectionRadioGroupJsx = !props.sow ? (
    <React.Fragment>
      <div className='path-selection-radiogroup-item'>
        <Radio
          id="path-selection-radio-no"
          name="radio"
          value="false"
          _value={props.forceGDocsPath}
          setInputvalue={(event) => props.handlePathSelectionRadioOnChange(event)}
        />
        <label htmlFor="path-selection-radio-no">No</label>
      </div>
      <div className='path-selection-radiogroup-item'>
        <Radio
          id="path-selection-radio-yes"
          name="radio"
          value="true"
          _value={props.forceGDocsPath}
          setInputvalue={(event) => props.handlePathSelectionRadioOnChange(event)}
        />
        <label htmlFor="path-selection-radio-yes">Yes</label>
      </div>
    </React.Fragment>
  ) : null;

  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}
    >
      <ModalHeader
        title={Translations(props.modal_draftDocumentation.modalTitle, props.lang.currentLang.lang, props.lang.translatedData)}
      />
      <ModalBody>
        <div className="gdocs-case-bodysubHead-parent">
          {props.isTbtEnabled && props.isTbtForceGDocsEnabled && props.showUserPathSelection && (
            <div className="path-selection-radiogroup-section">
              <p id="path-selection-label">
                Do you wish to force this through GDocs terms and conditions?
              </p>
              <div
                className="path-selection-radiogroup"
                role="radiogroup"
                aria-labelledby="path-selection-label"
              >
                {pathSelectionRadioGroupJsx}
              </div>
            </div>
          )}
          <span className="gdocs-case-bodysubHead">
            {Translations(props.modal_draftDocumentation.par1, props.lang.currentLang.lang, props.lang.translatedData)}
          </span>
          <div className="gdocs-case-bodysubHead-child">
            {
              caseIds.length > 1 && (
                <div className='checkbox-container'>
                  <Checkbox
                    onChange={props._selectAllCaseSelectedForDraftMultiEntity}
                    name={'selectAll'}
                    id={'selectAll'}
                    controlled
                    checked={props.selectAllFlag}
                  />
                  <label htmlFor={'selectAll'}>
                    <span><b>Select All</b></span>
                  </label>
                </div>
              )
            }
            {props.sow ? sowListJsx : entitiesListJsx}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-default return-btn"
          onClick={props.toggleDialog}
        >
          {Translations(props.sow ? props.modal_draftDocumentation.returnToSOW : props.modal_draftDocumentation.whiteBtn, props.lang.currentLang.lang, props.lang.translatedData)}
        </button>
        <button
          className="gdocs-btn-primary"
          onClick={props._onGenerateDraftClick}
          disabled={disabledBtn}
        >
          {Translations(props.modal_draftDocumentation.redBtn, props.lang.currentLang.lang, props.lang.translatedData)}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export const DraftGenerationSucessModal = (props) => {
  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}
    >
      <ModalHeader
        title={Translations(props.sow ? props.page_title_mainTitle.sowpageHeading : props.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)}
      /* title={props.isTbtFlow === true
        ? "TBT " + Translations(props.sow ? props.page_title_mainTitle.sowpageHeading : props.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData).toLowerCase()
        : Translations(props.sow ? props.page_title_mainTitle.sowpageHeading : props.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)
      } */
      />
      <ModalBody>
        <React.Fragment>
          <p>
            {Translations(props.sow ? props.page_title_mainTitle.sowdescriptionText1 : props.page_title_mainTitle.descriptionText1, props.lang.currentLang.lang, props.lang.translatedData)}
          </p>
          <p>
            {Translations(props.sow ? props.page_title_mainTitle.sowdescriptionText2 : props.page_title_mainTitle.descriptionText2, props.lang.currentLang.lang, props.lang.translatedData)}
          </p>
          <p>
            {Translations(props.sow ? props.page_title_mainTitle.sowdescriptionText3 : props.page_title_mainTitle.descriptionText3, props.lang.currentLang.lang, props.lang.translatedData)}
          </p>
          <p>
            {Translations(props.sow ? props.page_title_mainTitle.sowdescriptionText4 : undefined, props.lang.currentLang.lang, props.lang.translatedData)}
          </p>
        </React.Fragment>
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-primary"
          onClick={props._onOk}
        >
          {Translations(props.button_save.text, props.lang.currentLang.lang, props.lang.translatedData)}
        </button>
      </ModalFooter>
    </Modal>);
}

export const GenerateBgProcessModal = (props) => {
  return (
    props.static_text_generateDraftBgPopup ?
      (<Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
        <ModalHeader title={Translations(props.static_text_generateDraftBgPopup.headerText, props.lang.currentLang.lang, props.lang.translatedData)} />
        <ModalBody>
          {Translations(props.static_text_generateDraftBgPopup.bodyText, props.lang.currentLang.lang, props.lang.translatedData)}
        </ModalBody>
        <ModalFooter>
          <button
            className="gdocs-btn-primary"
            onClick={props._onOk}
          >
            {Translations(props.button_save.text, props.lang.currentLang.lang, props.lang.translatedData)}
          </button>
        </ModalFooter>
      </Modal>) : null
  );
}

export const FinalizeDocumentsModal = (props) => {
  const cases = props.cases;
  const caseIds = Object.keys(props.cases);

  let isFinalizeBtnDisabled = props.enableFinalizeBtn.length > 0 && props.isFinalizeConfirmationChecked ? false : true
  let entitiesListJsx = null;

  entitiesListJsx = caseIds.map((caseId) => (
    <div
      key={caseId}
      className={classnames('checkbox-container', cases[caseId].status !== DOCUMENTATION_DRAFT ? 'disabled' : '')}
    >
      <Checkbox
        onChange={props.casesSelectedForFinalizeMultiEntity}
        name={caseId}
        id={caseId}
        disabled={cases[caseId].status !== DOCUMENTATION_DRAFT}
        checked={props.enableFinalizeBtn.includes(caseId) && cases[caseId].status === DOCUMENTATION_DRAFT}
        controlled={props.enableFinalizeBtn.includes(caseId)}
      />
      <label htmlFor={caseId}>
        <span className="product-enablement-text">
          {`${cases[caseId].entityName}_${cases[caseId]._caseId}`}
        </span>
        <span><b>{` (${cases[caseId].statusValue})`}</b></span>
      </label>
    </div>
  ));

  return (
    <Modal
      show={props.showDialog}
      onClose={props.toggleDialog}
      bsClass={props.bsClass}
    >
      <ModalHeader
        title={props.translations(props.static_text_documentation.title)}
      />
      <ModalBody>
        <div className="gdocs-case-bodysubHead-parent">
          <div className="gdocs-case-bodysubHead">
            <p>{props.translations(props.static_text_documentation.par1)}</p>
            <p>{props.translations(props.static_text_documentation.par2)}</p>
            <p>{props.translations(props.static_text_documentation.par3)}</p>
          </div>
          <div className="gdocs-case-bodysubHead-child">
            {
              caseIds.length > 1 && (
                <div className='checkbox-container'>
                  <Checkbox
                    onChange={props.selectAllCasesForFinalizeMultiEntity}
                    name={'selectAll'}
                    id={'selectAll'}
                    controlled
                    checked={props.selectAllFinalizeFlag}
                  />
                  <label htmlFor={'selectAll'}>
                    <span><b>Select All</b></span>
                  </label>
                </div>
              )
            }
            {entitiesListJsx}
          </div>
        </div>
        <div className="checkbox-container">
          <Checkbox
            name="finalize-confirmation-checkbox"
            onChange={props.finalizeConfirmationCheckboxHandler}
            defaultChecked={false}
          />
          <label htmlFor="finalize-confirmation-checkbox">
            {props.translations(props.finalizeConfirmationText)}
          </label>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-default return-btn"
          onClick={props.doNotFinalize}
        >
          {props.translations(props.static_text_documentation.cancelText)}
        </button>
        <button
          className="gdocs-btn-primary"
          onClick={props.handleModalFinalizeClick}
          disabled={isFinalizeBtnDisabled}
        >
          {props.translations(props.static_text_documentation.buttonText)}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export const FinalizeBgProcessModal = (props) => {
  return (
    <Modal show={props.showDialog} onClose={props.toggleDialog} bsClass={props.bsClass}>
      <ModalHeader title="Document finalisation initiated" />
      <ModalBody>
        You will receive email confirmation when your documents finalisation is completed, and now be redirected to your case list.
      </ModalBody>
      <ModalFooter>
        <button
          className="gdocs-btn-primary"
          onClick={props._onOk}
        >
          OK
          {/* {props.translations(props.static_text_documentation.buttonText)} */}
        </button>
      </ModalFooter>
    </Modal>
  );
}

export const AddOwnerModal = (props) => {

  return (
    props.formJsonAddOwner !== undefined ?
      <Modal
        show={props.showDialog}
        onClose={props.toggleDialog}
        bsClass={props.bsClass}
      >
        <ModalHeader
          title={Translations(props.formJsonAddOwner.par.static_text_addOwner.addOwnerHeading, props.lang.currentLang.lang, props.lang.translatedData)}
        />
        <ModalBody>
          <div className="godcs-add-owner-radio">
            <label className="gdocs-mright-10">{Translations(props.formJsonAddOwner.par.guideradiobutton_assignRole.title, props.lang.currentLang.lang, props.lang.translatedData)}</label>
            <Radio
              id="cr-a"
              name="radio"
              setInputvalue={(event) => props._setOwnerRoll(event)}
              _value={props.primaryOwner}
              value="true"
              disabled={props.setListData.length >= 2 ? true : false}
            />
            <label htmlFor="cr-a">
              {props.primaryOwnerText}
            </label>
            <Radio
              id="cr-b"
              name="radio"
              setInputvalue={(event) => props._setOwnerRoll(event)}
              _value={props.primaryOwner}
              value="false"
              disabled={props.setListData.length >= 2 ? true : false}
            />

            <label htmlFor="cr-b">
              {props.secondaryOwnerText}
            </label>
          </div>

          <div className="gdocs-search-user-wrap">
            <label className="gdocs-mright-10">
              {Translations(props.formJsonAddOwner.par.static_text_searchUserText.label, props.lang.currentLang.lang, props.lang.translatedData)}</label>
            <AddUserSearchBox
              headerTitle='Add a Group'
              setSelectedOptions={(selectedUser) => props._getSelectedUser(selectedUser)}
              isDisable={props.setListData.length >= 2 ? true : false}
              sow={props.sow}
            />
          </div>
          {
            props._displaySelectedUser !== undefined && props._displaySelectedUser !== '' ?
              <div className="gdocs-mtop-20">
                <label className="gdocs-mright-10">{Translations(props.formJsonAddOwner.par.static_text_selectedUser.label, props.lang.currentLang.lang, props.lang.translatedData)}</label>
                <label><strong>{props._displaySelectedUser}</strong></label>
              </div> : ''
          }
          <div className="gdocs-mtop-10">
            {Translations(props.formJsonAddOwner.par.static_text_listCaseOwners.label, props.lang.currentLang.lang, props.lang.translatedData)}
          </div>
          <ul className="godcs-user-list">
            {
              props.setListData.map((curr, index) => {
                return (
                  <div className="gdocs-user-list-container">
                    <li key={index}>
                      <span className="gdocs-user-name">{curr.userName}</span>
                      <span className="gdocs-mleft-25">{curr.primaryOwner !== undefined ? curr.primaryOwner === true ? props.primaryOwnerText : props.secondaryOwnerText : ''}</span>
                    </li>
                    {props.setListData.length > 1 ?
                      <span className="icon icon-bin deleteIcon gdocs-float-left" data-key={curr.email} onClick={(event) => props._deleteAddedOwner(event)}></span> : ''}
                  </div>
                )
              })
            }
          </ul>
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default gdocs-mright-20" onClick={props.toggleDialog}>
            {
              Translations(props.formJsonAddOwner.par.guidebutton_cancel.text, props.lang.currentLang.lang, props.lang.translatedData)
            }
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={props._submitOwner}
            disabled={props.setListData.length >= 2 || props.primaryOwner === '' || (props._displaySelectedUser === undefined && props._displaySelectedUser === '') ? true : false}
          >
            {Translations(props.formJsonAddOwner.par.guidebutton_submit.text, props.lang.currentLang.lang, props.lang.translatedData)}
          </button>

        </ModalFooter>
      </Modal> : '');
}

export class CancelCaseModal extends Component {

  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render() {
    let statusobj = { pointerEvents: "none" }
    if (this.props._cancelReason !== '') {
      statusobj = {}
    }

    return (
      <Modal
        show={this.props.showDialog}
        onClose={this.props.toggleDialog}
        bsClass={this.props.bsClass}
      >
        <ModalHeader
          title={Translations(this.props.sow ? this.props.page_title_mainTitle.sowpageHeading : this.props.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        />
        <ModalBody>
          <div className={Object.keys(this.props._getCases).length > 1 ? 'gdocs-case-bodysubHead-parent' : "noDisplay"}>
            <span className="gdocs-case-bodysubHead">{Translations(this.props.sow ? this.props.modal_cancelCase.sowmessage : this.props.modal_cancelCase.message, this.props.lang.currentLang.lang, this.props.lang.translatedData)}</span>
            <div className="gdocs-case-bodysubHead-child">
              {
                Object.keys(this.props._getCases).map((caseId, index) => {
                  if (this.props._getCases[caseId].status !== CASE_CANCELLED) {
                    return (
                      <div
                        key={caseId}
                        className={`checkbox-container ${(this.props._getCases[caseId].status === CASE_COMPLETED) ? 'disabled' : ''}`}
                      >
                        <Checkbox
                          onChange={this.props._entityChecked}
                          id={caseId}
                          name={`cancelCase-${this.props._getCases[caseId].caseId}`}
                          disabled={this.props._getCases[caseId].status === CASE_COMPLETED}
                          tabIndex="0"
                        />
                        <label htmlFor={"cancelCase-" + caseId}>
                          {`${this.props._getCases[caseId].entityName} (${this.props._getCases[caseId]._caseId})`}
                        </label>
                      </div>
                    )
                  } else {
                    return '';
                  }
                })
              }
            </div>
          </div>
          <span className="gdocs-case-bodysubHead">
            {Translations(this.props.sow ? this.props.page_title_mainTitle.sowdescriptionText : this.props.page_title_mainTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </span>
          <div className="cancel-case-radio-btn">
            <div className="cancelCaseRadio">
              <Radio
                id="cr-1"
                name="radio"
                value={this.translateWord(this.props.modal_cancelCase.fieldLabels)[0]}
                _value={this.props._cancelReason}
                setInputvalue={(event) => this.props._setRadioSelection(event)}
                tabIndex="0"
              />
              <label htmlFor="cr-1">
                {this.translateWord(this.props.modal_cancelCase.fieldLabels)[0]}
              </label>
            </div>
            <div className="cancelCaseRadio">
              <Radio
                id="cr-2"
                name="radio"
                value={this.translateWord(this.props.modal_cancelCase.fieldLabels)[1]}
                _value={this.props._cancelReason}
                setInputvalue={(event) => this.props._setRadioSelection(event)}
                tabIndex="0"
              />
              <label htmlFor="cr-2">
                {this.translateWord(this.props.modal_cancelCase.fieldLabels)[1]}
              </label>
            </div>
            <div className="cancelCaseRadio">
              <Radio
                id="cr-3"
                name="radio"
                value={this.translateWord(this.props.modal_cancelCase.fieldLabels)[2]}
                _value={this.props._cancelReason}
                setInputvalue={(event) => this.props._setRadioSelection(event)}
                tabIndex="0"
              />
              <label htmlFor="cr-3">
                {this.translateWord(this.props.modal_cancelCase.fieldLabels)[2]}
              </label>
            </div>
            <div className="cancelCaseRadio">
              <Radio
                id="cr-4"
                name="radio"
                value={this.translateWord(this.props.modal_cancelCase.fieldLabels)[3]}
                _value={this.props._cancelReason}
                setInputvalue={(event) => this.props._setRadioSelection(event)}
                tabIndex="0"
              />
              <label htmlFor="cr-4" >
                {this.translateWord(this.props.modal_cancelCase.fieldLabels)[3]}
              </label></div>
            <div className="cancelCaseRadio">
              <Radio
                id="cr-5"
                name="radio"
                value={this.translateWord(this.props.modal_cancelCase.fieldLabels)[4]}
                _value={this.props._cancelReason}
                setInputvalue={(event) => this.props._setRadioSelection(event)}
                tabIndex="0"
              />
              <label htmlFor="cr-5">
                {this.translateWord(this.props.modal_cancelCase.fieldLabels)[4]}
              </label>
            </div>
          </div>
          <div className="cancel-case-checkbox">
            <div className="cancel-case-checkbox-child" style={statusobj}>
              <Checkbox
                name="cancel-case-final-acceptance"
                onChange={this.props._onChange}
                defaultChecked={this.props._checked}
                tabIndex="0"
              />
            </div>
            <label htmlFor="cancel-case-final-acceptance">
              {Translations(this.props.sow ? this.props.modal_cancelCase.sowtext : this.props.modal_cancelCase.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="gdocs-btn-default return-btn"
            onClick={this.props.toggleDialog}
          >
            {Translations(this.props.sow ? this.props.modal_cancelCase.sowreturnText : this.props.modal_cancelCase.returnText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </button>
          <button
            className="gdocs-btn-primary"
            onClick={this.props._onCancelCase}
            disabled={this.props._setDisabled}
          >
            {Translations(this.props.sow ? this.props.modal_cancelCase.sowcancelText : this.props.modal_cancelCase.cancelText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

export class ShareCaseConfirmation extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  render() {
    return (
      (this.props.formJsonInviteSent !== undefined
        ? <Modal
          show={this.props.showDialog}
          onClose={this.props.toggleDialog}
          bsClass={this.props.bsClass}
        >
          <ModalHeader title={this.props.modalTitle} />
          <ModalBody>
            <div className="gdoc-share-case-headn">
              <div className="icon icon-circle-confirmation-solid gdoc-share-case-conf-icon gdoc-share-case-conf-icon-float"></div>
              <h2 className="gdoc-share-case-conf-icon-float">
                {Translations(this.props.formJsonInviteSent.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              </h2>
            </div>
            <div className="gdoc-share-case-conf-clearbth"></div>
            <div className="gdocs-share-case-conf-desc-headn">
              {Translations(this.props.formJsonInviteSent.par.page_title_mainTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </div>
            {this.props.customer
              ? <div className="gdoc-share-case-desctn">
                <div>
                  {Translations(this.props.formJsonInviteSent.par.page_title_static_text.text1, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
                <div className="gdocs-share-case-conf-padn">
                  {Translations(this.props.formJsonInviteSent.par.page_title_static_text.text2, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
              </div>
              : <div className="gdoc-share-case-desctn">
                <div>
                  {Translations(this.props.sow ? this.props.formJsonInviteSent.par.page_title_static_text.sowText1 : this.props.formJsonInviteSent.par.page_title_static_text.text1, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
                <div className="gdocs-share-case-conf-padn">
                  {Translations(this.props.sow ? this.props.formJsonInviteSent.par.page_title_static_text.sowText2 : this.props.formJsonInviteSent.par.page_title_static_text.text2, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
              </div>
            }
          </ModalBody>
          <ModalFooter>
            <button
              className="gdocs-btn-primary"
              onClick={this.props.toggleDialog}
            >
              {Translations(this.props.formJsonInviteSent.par.button_ok.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </button>
          </ModalFooter>
        </Modal>
        : '')
    );
  }
}
export class CopytoAccountModal extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  onFormSubmitcopyData = (data) => {
    this.props._onFormSubmitcopyData(data);
  }

  render() {
    return (
      (this.props.copyToaccountformJson !== undefined) ?
        <Modal show={this.props.showDialog} onClose={this.props.toggleDialog} bsClass={this.props.bsClass}>
          <ModalHeader title={this.props.translations(this.props.copyToaccountformJson.guideContainer.rootPanel.items.static_text_mainTitle.text)} />
          <ModalBody>
            <div>
              <p>
                {this.props.translations(this.props.copyToaccountformJson.guideContainer.rootPanel.items.guidecheckbox_whatToCopy.title)}
              </p>
              <div>
                {
                  this.props.translateWordForOption(this.props.copyToaccountformJson.guideContainer.rootPanel.items.guidecheckbox_whatToCopy.options).map((option, index) => {
                    var splitOption = option.split('=')[1];
                    var splitOptionKey = option.split('=')[0]
                    return (
                      <div key={index}>
                        <Checkbox name={splitOptionKey} onChange={this.props._setData} className="gdocs-set-check" />
                        <label className="product-enablement-text">{splitOption}</label>
                      </div>
                    )
                  })
                }
              </div>
            </div>
            <hr />
            <div>
              <p>{this.props.translations(this.props.copyToaccountformJson.guideContainer.rootPanel.items.guidecheckbox_copyToAccount.title)}</p>
              <div className="gdocs-accountListdata">
                {
                  this.props._filteredAccount.map((item, index) => {
                    return (
                      <div key={index} className="gdocs-accountList">
                        <Checkbox name={item.id} onChange={this.props._setAccountdata} className="gdocs-set-check" />
                        <label className='accountListAccHeading' role="link">
                          {`${item.accountType ? item.accountType.name : item.accountNumber}, ${item.country.name} ${item.currency ? `, ${item.currency.name}` : ''}`}
                          <div className="navListDesc acountListDesc">{`${item.accountHolder.name}, ${item.accountTitle !== undefined && item.accountTitle !== '' ? `(${item.accountTitle})` : ''}`}</div>
                        </label>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="gdocs-btn-default gdocs-mright-20" onClick={this.props.toggleDialog}>{this.props.translations(this.props.copyToaccountformJson.guideContainer.rootPanel.items.guidebutton_cancel.text)}</button>
            <button className="gdocs-btn-primary" onClick={this.props._onFormSubmitcopyData}>{this.props.translations(this.props.copyToaccountformJson.guideContainer.rootPanel.items.guidebutton_apply.text)}</button>

          </ModalFooter>
        </Modal>
        : '')
  }
}

const validate = (firstName, lastName, email, selectedLang, formJson) => {
  const regexPattern = formJson.text_box_emailAddress.regex;
  return {
    firstName: firstName.length === 0,
    lastName: lastName.length === 0,
    email: email.length === 0 || new RegExp(regexPattern).test(email) === false,
    selectedLang: selectedLang.length === 0,
  };
}

export class SendToClientModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      selectedLang: '',
      touched: {
        firstName: false,
        lastName: false,
        email: false,
        selectedLang: false,
      }
    }
  }

  handleBlur = field => evt => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  handleSubmit = evt => {
    if (!this.canBeSubmitted()) {
      evt.preventDefault();
      return;
    }
    const { firstName, lastName, email, selectedLang } = this.state;
    var data = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      language: selectedLang
    }
    this.props.onFormSubmitClientToSend(data);
  };

  canBeSubmitted = () => {
    const errors = validate(this.state.firstName, this.state.lastName, this.state.email, this.state.selectedLang, this.props.formJsonClientToSend.par);
    const isDisabled = Object.keys(errors).some(x => errors[x]);
    return !isDisabled;
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    }, () => { });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps._resetStateVals === true) {
      this.setState({
        firstName: '',
        lastName: '',
        email: '',
        selectedLang: '',
        touched: {
          firstName: false,
          lastName: false,
          email: false,
          selectedLang: false,
        }
      })
    }
  }


  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  render() {
    const errors = validate(this.state.firstName, this.state.lastName, this.state.email, this.state.selectedLang, this.props.formJsonClientToSend.par);
    const isDisabled = Object.keys(errors).some(x => errors[x]);

    const displayError = field => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];

      return hasError ? shouldShow : false;
    };

    if (this.props.formJsonClientToSend !== undefined && this.props.formJsonClientToSend.par !== null && this.props.formJsonClientToSend.par !== undefined) {
      return (
        <div className="gdoc-invite-collabrative">
          <Modal
            show={this.props.showDialog}
            onClose={this.props.toggleDialog}
            bsClass={this.props.bsClass}
          >
            <ModalHeader title={this.props.modalTitle} />
            <ModalBody>
              <h2 className="gdoc-share-case-headn" >
                {Translations(this.props.sow ? this.props.formJsonClientToSend.par.page_title_mainTitle.sowPageHeading : this.props.formJsonClientToSend.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              </h2>
              {this.props.customer
                ? <div className="gdoc-share-case-desctn">
                  {Translations(this.props.formJsonClientToSend.par.page_title_mainTitle.descriptionText2, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
                : <div className="gdoc-share-case-desctn">
                  {Translations(this.props.sow ? this.props.formJsonClientToSend.par.page_title_mainTitle.sowDescriptionText1 : this.props.formJsonClientToSend.par.page_title_mainTitle.descriptionText1, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
              }
              <form className="gdoc-modal-send-to-client">
                <div className="gdoc-modal-send-to-client-invite-headn">
                  {Translations(this.props.formJsonClientToSend.par.page_title_static_text.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
                <div>
                  <label className="gdoc-share-case-set-label" htmlFor="firstName">
                    {Translations(this.props.formJsonClientToSend.par.text_box_FirstName.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    aria-describedby="firstNameerror"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur('firstName')}
                  />
                  {
                    displayError("firstName") ? (
                      <div className="input-error-msg-section gdocs-error-align" role="alert" id="firstNameerror">
                        <span className="icon icon-circle-delete-solid"></span>
                        {Translations(this.props.formJsonClientToSend.par.text_box_FirstName.mandatoryMessage, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                      </div>
                    ) : ''
                  }
                  <label className="gdoc-share-case-set-label" htmlFor="lastName">
                    {Translations(this.props.formJsonClientToSend.par.text_box_lastName.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    id="lastName"

                    aria-describedby="lastNameerror"
                    onChange={this.handleChange}
                    onBlur={this.handleBlur('lastName')}
                  />
                  {
                    displayError("lastName") ? (
                      <div className="input-error-msg-section gdocs-error-align" role="alert" id="lastNameerror">
                        <span className="icon icon-circle-delete-solid"></span>
                        {Translations(this.props.formJsonClientToSend.par.text_box_lastName.mandatoryMessage, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                      </div>
                    ) : ''
                  }
                  <div className="gdoc-share-case-label-email-container">
                    <label className="gdoc-share-case-set-label gdoc-share-case-label-email" htmlFor="email">
                      {Translations(this.props.formJsonClientToSend.par.text_box_emailAddress.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"

                      aria-describedby="emailerror"
                      onChange={this.handleChange}
                      onBlur={this.handleBlur('email')}
                    />
                  </div>
                  {
                    displayError("email") ? (
                      <div className="input-error-msg-section gdocs-error-align" role="alert" id="emailerror">
                        <span className="icon icon-circle-delete-solid"></span>
                        {Translations(this.props.formJsonClientToSend.par.text_box_emailAddress.regexValidationMessage, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                      </div>
                    ) : ''
                  }

                </div>
                <div className="gdoc-modal-send-to-client-invite-lang-headn">
                  {Translations(this.props.formJsonClientToSend.par.page_title_static_text2.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </div>
                <label className="gdoc-share-case-set-label gdocs-mtop-10 gdocs-valign-top" for='selectedLang' >
                  {Translations(this.props.formJsonClientToSend.par.dropdown_language.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                </label>
                <div className="display-inline">
                  <SimpleDropdown
                    options={[
                      {
                        id: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[0]}`,
                        name: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[0]}`
                      },
                      {
                        id: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[1]}`,
                        name: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[1]}`
                      },
                      {
                        id: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[2]}`,
                        name: `${this.translateWord(this.props.formJsonClientToSend.par.dropdown_filterRole.options)[2]}`
                      }
                    ]}
                    value={this.state.selectedLang}
                    _onChange={this.handleChange}
                    optionTextSelector="name"
                    defaultValue={Translations(this.props.formJsonClientToSend.par.dropdown_filterRole.defaultText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                    name='selectedLang'
                    id='selectedLang'

                    ariadescribedby="selectedLangerror"
                    disabled={this.state.disableCountryList}
                    _onBlur={this.handleBlur('selectedLang')}
                    tabIndex="0"
                  />
                </div>
                {
                  displayError("selectedLang") ? (
                    <div className="input-error-msg-section gdocs-error-align" role="alert" id="selectedLangerror">
                      <span className="icon icon-circle-delete-solid"></span>
                      {Translations(this.props.formJsonClientToSend.par.dropdown_language.mandatoryMessage, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                    </div>
                  ) : ''
                }
                {
                  !this.props.customer && Object.keys(this.props.cases).length > 1
                    ? <div>
                      <div className="gdoc-modal-send-to-client-invite-lang-headn">
                        {Translations(this.props.formJsonClientToSend.par.page_title_static_text3.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                      </div>
                      <div>
                        {
                          Object.keys(this.props.cases).map((caseId, index) =>
                            <div className="checkbox-container gdocs-mtop-15" key={index}>
                              <Checkbox
                                onChange={this.props._sentToClientChecked}
                                id={caseId}
                                name={`sentToClient-${this.props.cases[caseId].caseId}`}
                                disabled={this.props.cases[caseId].status === CASE_COMPLETED}
                                tabIndex="0"
                                ariadescribedby="checkError"
                              />
                              <label htmlFor={caseId}>
                                <span className="product-enablement-text">
                                  {`${this.props.cases[caseId].entityName}_${this.props.cases[caseId]._caseId}`}
                                </span>
                                <span>
                                  <b>{`- Case (${this.props.cases[caseId]._caseId})`}</b>
                                </span>
                              </label>
                            </div>
                          )
                        }
                        {
                          (this.props._showCheck === false) ? (
                            <div className="input-error-msg-section" role="alert" id="checkError">
                              <span className="icon icon-circle-delete-solid" ></span>
                              {Translations(this.props.formJsonClientToSend.par.page_title_mainTitle.descriptionText3, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                            </div>
                          ) : ''
                        }
                      </div>
                    </div>
                    : ''
                }
              </form>
            </ModalBody>
            <ModalFooter>
              <div className="delete-group-model--body">
                <div className="gdocs-float-right">
                  <button className="gdoc-share-case-modal-cancel" onClick={this.props.toggleDialog} style={{ border: "white", background: "white" }}>
                    {Translations(this.props.formJsonClientToSend.par.button_cancel.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </button>
                  <button className="gdocs-btn-primary" onClick={this.handleSubmit} disabled={isDisabled || (this.props._noOfEntities > 1 || this.props._showCheck !== undefined ? this.props._showCheck === false || this.props._showCheck === undefined ? true : false : false)}>
                    {Translations(this.props.formJsonClientToSend.par.button_sendInvite.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
                  </button>
                </div>
                <div className="gdoc-admin-login-clearbth"></div>
              </div>
            </ModalFooter>
          </Modal>
        </div>);
    } else {
      return (<h1>Loading.....</h1>);
    }
  }
}

export class EditProductEnablementModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProductEnablements: [],
      selectedOtherProducts: "",
      editedProducts: [],
      showOtherProductsList: false
    };
  }

  componentWillReceiveProps(nextProps) {
    let selectedProductEnablements = [],
      selectedOtherProducts = '',
      editedProducts = [];
    if (nextProps.accountForEditType === "gdocs-account") {
      let echannelReporting = (nextProps.accountForEdit ? nextProps.accountForEdit.eChannelReporting.find(er => er.eChannelId === this.props.currentEchannel.id) : {});
      selectedProductEnablements = echannelReporting.productEnablements || [];
      selectedOtherProducts = echannelReporting.otherProductEnablements;
    } else if (nextProps.accountForEditType === "third-party-account" && nextProps.accountForEdit) {
      selectedProductEnablements = nextProps.accountForEdit.productEnablements || [];
      selectedOtherProducts = nextProps.accountForEdit.otherProductEnablements;
    }
    selectedOtherProducts = getArrayToString(getStringToArray(selectedOtherProducts).concat(getStringToArray(nextProps.selectedOtherProducts)))
    editedProducts = selectedProductEnablements.map(spe => spe.id);
    this.setState({ selectedProductEnablements, selectedOtherProducts, editedProducts });
  }

  isProductSelected(productId) {
    return this.state.selectedProductEnablements.some(sp => sp.id === productId);
  }

  onProductChecked = (event) => {
    let editedProducts = [...this.state.editedProducts];
    if (event.target.checked) {
      editedProducts.push(event.target.name.substring(0, event.target.name.length - 4));
    } else {
      editedProducts.remove(event.target.name.substring(0, event.target.name.length - 4));
    }
    this.setState({ editedProducts });
  }

  onOtherProductsEdit = (event) => {
    this.setState({ selectedOtherProducts: event.target.value });
  }

  apply = () => {
    this.props.onApplyEnabelmentsToProduct(this.props.accountForEditType, this.state.editedProducts, this.state.selectedOtherProducts, this.props.accountsReportingToEchannel);
    this.setState({
      selectedProductEnablements: [],
      selectedOtherProducts: "",
      editedProducts: []
    });
    this.props.toggleDialog();
    this.setState({ showOtherProductsList: false })
    this.props.resetSelectedOtherProducts()
  }

  setNotListedOtherProducts = (e) => {
    this.setState({
      selectedOtherProducts: e.target.value
    })
  }

  render() {
    const productsListSet1 = this.props.productsList.slice(null, this.props.productsList.length / 2);
    const productsListSet2 = this.props.productsList.slice(this.props.productsList.length / 2);
    const currentEchannelType = this.props.currentEchannel && this.props.currentEchannel.eChannelType && this.props.currentEchannel.eChannelType.value;
    let swiftnetProductList;
    if (currentEchannelType === 'urn:hsbc:cmb:gdocs:products:taxonomies:echannelType:swiftNet') {
      swiftnetProductList = this.props.swiftnetProductList;
    }

    return (
      <Modal show={this.props.showDialog} onClose={this.props.toggleDialog} bsClass={this.props.bsClass}>
        <ModalHeader title={this.props.modalTitle} />
        {
          this.props.accountForEdit ? (
            <ModalBody>
              <div className="account-details-header">
                {
                  this.props.accountForEditType === 'gdocs-account' ? [
                    <p key="gdocs-account-heading-1">{`${this.props.accountForEdit.accountType ? this.props.accountForEdit.accountType.name : this.props.accountForEdit.accountNumber}, ${this.props.accountForEdit.country.name} ${this.props.accountForEdit.currency ? `, ${this.props.accountForEdit.currency.name}` : ''}`}</p>,
                    <p key="gdocs-account-heading-2"><span>{this.props.accountForEdit.accountHolder.name}</span> <span className="light-text">{`${this.props.accountForEdit.accountType ? `(${this.props.accountForEdit.accountTitle || this.props.accountForEdit.tempRefrenceId})` : ''}`}</span></p>
                  ] : [
                    <p key="third-party-account-heading-1">{`${this.props.accountForEdit.accountNumber}, ${this.props.accountForEdit.country.name} ${this.props.accountForEdit.currency ? `, ${this.props.accountForEdit.currency.name}` : ''}`}</p>,
                    <p key="third-party-account-heading-2"><span>{this.props.accountForEdit.tradingName}</span> <span className="light-text">{`(${this.props.accountForEdit.branchCode})`}</span></p>
                  ]
                }
              </div>
              <div className="products-list">
                <div className="gdocs-float-left">
                  {
                    productsListSet1.map(product => {
                      return (
                        <div key={product.id + 'Edit'}>
                          <Checkbox onChange={this.onProductChecked} id={product.id + 'Edit'} name={product.id + 'Edit'} defaultChecked={this.isProductSelected(product.id)} />
                          <label htmlFor={product.id + 'Edit'} className="product-enablement-text">{`${product.name} (${product.description})`}</label>
                        </div>
                      )
                    })
                  }
                </div>
                <div className="gdocs-float-right">
                  <div className="left-section">
                    {
                      productsListSet2.map(product => {
                        return (
                          <div key={product.id + 'Edit'}>
                            <Checkbox onChange={this.onProductChecked} id={product.id + 'Edit'} name={product.id + 'Edit'} defaultChecked={this.isProductSelected(product.id)} />
                            <label htmlFor={product.id + 'Edit'} className="product-enablement-text">{`${product.name} (${product.description})`}</label>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="right-section">
                    {
                      swiftnetProductList ?
                        swiftnetProductList.map(product => {
                          return (
                            <div key={product.id + 'Edit'}>
                              <Checkbox onChange={this.onProductChecked} id={product.id + 'Edit'} name={product.id + 'Edit'} defaultChecked={this.isProductSelected(product.id)} />
                              <label htmlFor={product.id + 'Edit'} className="product-enablement-text">{`${product.name}`}</label>
                            </div>
                          )
                        }) : ''
                    }
                  </div>
                </div>
                <div className="gdocs-clear-float"></div>
              </div>
              <section>
                <label className="other-products-label">{this.props.otherLabel} </label>
                <section className="gdocs-display-flex gdocs-align-items-center">
                  {
                    <section class="selected-otherproducts-section disabled gdocs-mright-30">
                      {this.state.selectedOtherProducts}
                    </section>
                  }
                  {
                    <section className="select-others-link-container"
                      role="button"
                      tabindex="0"
                    >
                      <span className="select-others-link-plus-icon">+</span>
                      <a
                        className="select-others-link"
                        onClick={() => { this.setState({ showOtherProductsList: true }) }}

                      >
                        {this.props.addOtherPorductsLinkText}
                      </a>
                    </section>
                  }
                </section>
              </section>
              {
                this.state.showOtherProductsList ?
                  <section style={{ marginTop: 10 }}>
                    <OtherProductsList
                      unlistedotherProductsInputLabel={this.props.unlistedotherProductsInputLabel}
                      otherProductsList={this.props.otherProductsList}
                      selectedOtherProducts={this.state.selectedOtherProducts}
                      getCheckedOtherProducts={(checkedItems) => {
                        this.setState({ selectedOtherProducts: getArrayToString(checkedItems, true, true, "description") })
                      }} type={this.props.accountForEditType}
                      productsList={this.props.productsList}
                    ></OtherProductsList>
                  </section> : null
              }

              <hr />
            </ModalBody>
          ) : null
        }
        <ModalFooter>
          <button className="gdocs-btn-default" onClick={() => {
            this.props.toggleDialog();
            this.setState({ showOtherProductsList: false })
          }}>{this.props.cancelBtn}</button>
          <button className="gdocs-btn-primary" onClick={this.apply}>{this.props.applyBtn}</button>
        </ModalFooter>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/Modals/index.js